export const Feature = {
    ILLNESS: "Feature.ILLNESS",
    HUGS: "Feature.HUGS",
    DEPARTMENTSLOCKED: "Feature.DEPARTMENTSLOCKED",
    TASKS: "Feature.TASKS",
    STORAGE: "Feature.STORAGE",
    EXTERNAL: "Feature.EXTERNAL",
};